<div
  class="ui segment"
  appMargin
  marginB="3"
  fxLayout="row"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
>
  <div fxFlex="5%">
    <sui-checkbox> </sui-checkbox>
  </div>
  <div fxFlex="25%">{{ role?.roleName }}</div>
  <div fxFlex>{{ role?.roleDescription }}</div>
  <div fxFlex class="text-right">
    <a
      *isPermitted="{ id: 'ROLES_MANAGEMENT', action: 'edit' }"
      class="ui circular tiny button"
      routerLink="/contractor/setting/role/detail/{{ role.roleId }}"
      ><i class="eye icon"></i
    ></a>

    <ng-template
      [ngIf]="
        role.roleId !== 'CONTRACTOR_MID_LEVEL_STAFF' &&
        role.roleId !== 'CONTRACTOR_ADMIN' &&
        role.roleId !== 'CONTRACTOR_BASIC_STAFF'
      "
    >
      <button
        class="ui circular tiny button"
        *isPermitted="{ id: 'ROLES_MANAGEMENT', action: 'remove' }"
        (click)="onDelete.emit(role)"
      >
        <i class="trash icon"></i>
      </button>
    </ng-template>
  </div>
</div>
